module.exports = __webpack_public_path__ + "media/images/logo_name-926a9203.svg";